import { render, staticRenderFns } from "./NameRenderer.vue?vue&type=template&id=cd8f3e68"
import script from "./NameRenderer.vue?vue&type=script&lang=ts"
export * from "./NameRenderer.vue?vue&type=script&lang=ts"
import style0 from "./NameRenderer.vue?vue&type=style&index=0&id=cd8f3e68&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports